// colors
// GREY
export const grey000 = "#FFFFFF";
export const grey100 = "#FAFAFA";
export const grey200 = "#F5F5F5";
export const grey300 = "#EDEDED";
export const grey400 = "#E5E5E5";
export const grey500 = "#CDCDCD";
export const grey600 = "#A8A8A8";
export const grey700 = "#747474";
export const grey800 = "#393939";
export const grey900 = "#000000";

// BLUE
export const blue050 = "#F4FBFF";
export const blue100 = "#E5F1FF";
export const blue200 = "#CBDCFF";
export const blue300 = "#AFC1FF";
export const blue400 = "#798AFF";
export const blue500 = "#3C46FF";
export const blue600 = "#0000FF";
export const blue700 = "#0404AC";
export const blue800 = "#020267";
export const blue900 = "#00002E";

// GREEN
export const green050 = "#F4FFF4";
export const green100 = "#E9FFE8";
export const green200 = "#D8FFD8";
export const green300 = "#C9FFC7";
export const green400 = "#A6FFA3";
export const green500 = "#7DF178";
export const green600 = "#51DA4B";
export const green700 = "#3FA93A";
export const green800 = "#2D7129";
export const green900 = "#183718";

// RED
export const red050 = "#FFF7F6";
export const red100 = "#FFEDEC";
export const red200 = "#FFDEDB";
export const red300 = "#FFD3C9";
export const red400 = "#FFB7A4";
export const red500 = "#FF9574";
export const red600 = "#FF6E3D";
export const red700 = "#FF4500";
export const red800 = "#AA2E00";
export const red900 = "#541700";

export const mainStyles = {
  primaryButton: {
    padding: { xs: "12px 20px", sm: "16px 24px" },
    borderRadius: "1000px",
    backgroundColor: blue600,
    "&:hover": {
      backgroundColor: blue700,
    },
    "&.Mui-disabled": {
      backgroundColor: blue300,
    },
  },
  primaryButtonText: {
    fontFamily: "Inter, sans-serif",
    color: grey000,
    fontSize: "16px",
    fontWeight: 600,
    lineHeight: "24px",
    letterSpacing: "0px",
  },
  secondaryButton: {
    padding: { xs: "12px 20px", sm: "16px 24px" },
    borderRadius: "1000px",
    backgroundColor: grey000,
    "&:hover": {
      backgroundColor: blue200,
    },
  },
  secondaryButtonText: {
    fontFamily: "Inter, sans-serif",
    color: blue600,
    fontSize: "16px",
    fontWeight: 600,
    lineHeight: "24px",
    letterSpacing: "0px",
  },
  linkButton: {
    padding: { xs: "12px 20px", sm: "16px 24px" },
    borderRadius: "1000px",
    background: "transparent",
    "&:hover": {
      backgroundColor: "transparent",
      color: blue900,
    },
  },
  linkButtonText: {
    fontFamily: "Inter, sans-serif",
    color: blue600,
    fontSize: "16px",
    fontWeight: 600,
    lineHeight: "24px",
    "&:hover": {
      color: blue700,
    },
    letterSpacing: "0px",
  },
  dangerButton: {
    padding: { xs: "12px 20px", sm: "16px 24px" },
    borderRadius: "1000px",
    backgroundColor: grey000,
    "&:hover": {
      backgroundColor: red200,
    },
    "&.Mui-disabled": {
      backgroundColor: grey400,
    },
  },
  dangerButtonText: {
    fontFamily: "Inter, sans-serif",
    color: red800,
    fontSize: "16px",
    fontWeight: 600,
    lineHeight: "24px",
    letterSpacing: "0px",
  },
  btnBorder: {
    border: `1px solid ${grey400}`,
  },
};
